import React, {useEffect, useState} from 'react';
import { Skeleton } from 'antd-mobile';

import './MayBeOneImg.scss';
// const imageUtil = require("../../utils/image");
import imageUtil from '../../utils/image';
import { IImageMayBe } from '../../global';
import classnames from 'classnames';
interface IMayBeOneImg {
  maybe: IImageMayBe;
  active: boolean;
  onClick: (url?:string) => void;
}

export const getFaceUrl = (maybe: IImageMayBe) => {
  const { hash, id } = maybe.image;
  let { shape = {} } = maybe;
  // 兼容某些情况下这个是个string的情况
  if (typeof shape === 'string') {
    try {
      shape = JSON.parse(shape);
    } catch (e) {}
  }
  const theUrl = imageUtil.style(
    hash,
    'face',
    {
      shape,
      webp:true
    },
    id
  );

  return theUrl;
};

export default (props: IMayBeOneImg) => {
  const { active, maybe, onClick } = props;
  const theUrl = getFaceUrl(maybe);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!theUrl) {
      setLoaded(false);
      return;
    }
    setLoaded(false);
    const img = new Image();
    img.onload = () => setLoaded(true);
    img.onerror = () => setLoaded(true);
    img.src = theUrl;
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [theUrl]);

  return (
      <div
          className={classnames('maybe-one-wrapper', { active })}
          onClick={() => onClick?.(theUrl)}
          style={{ position: 'relative' }} // 确保作为定位参考
      >
        {/* Skeleton 层 */}
        <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              opacity: loaded ? 0 : 1,
              transition: 'opacity 0.3s ease',
              pointerEvents: 'none', // 避免遮挡点击
            }}
        >
          <Skeleton animated style={{ width: '100%', height: '100%' }} />
        </div>

        {/* 真实图片层 */}
        <div
            className="maybe-one-real-img"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url(${theUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: loaded ? 1 : 0,
              transition: 'opacity 0.3s ease',
            }}
        />
      </div>
  );
};
